export const createModifiedDataPath = (
	vid: string,
	rowIndex: number,
	id = "display",
	index?: number
) => `${vid}___${rowIndex}___${index !== undefined ? `${id}/${index}` : id}`;
